import * as actions from "./actionsType";

const initialData = {
  loaderFormEvalCapa: false,
  formEvalCapa: null,
  formEvalCapaFail: null,
  saveLoaderFormEvalCapa: false,
  formEvalCapaFormError: null,
  
};

export default function FormEvalCapaReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_FORMEVALCAPA:
      return { ...state, loaderFormEvalCapa: action.payload };

    case actions.GET_FORMEVALCAPA:
      return { ...state, formEvalCapa: action.payload };

    case actions.FORMEVALCAPA_FAIL:
      return { ...state, formEvalCapaFail: action.payload };

    case actions.SAVE_LOADER_FORMEVALCAPA:
      return { ...state, saveLoaderFormEvalCapa: action.payload };

    case actions.FORM_FORMEVALCAPA_FAIL:
      return { ...state, formEvalCapaFormError: action.payload };

    default:
      return state;
  }
}